module.exports = __webpack_public_path__ + "img/6.2f9ced0f.png";